import { render, staticRenderFns } from "./FeedContentReviewPosition.vue?vue&type=template&id=2f74a938"
import script from "./FeedContentReviewPosition.vue?vue&type=script&lang=js"
export * from "./FeedContentReviewPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports